var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.312,
    height: 46.312,
    viewBox: "0 0 46.312 46.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_twotone_lock",
    "data-name": "vuesax/twotone/lock",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(172 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,15.437V11.578C0,5.191,1.93,0,11.578,0S23.156,5.191,23.156,11.578v3.859",
    transform: "translate(11.578 3.859)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M9.648,4.824A4.824,4.824,0,1,1,4.824,0,4.824,4.824,0,0,1,9.648,4.824Z",
    transform: "translate(18.332 26.051)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M28.945,23.156H9.648C1.93,23.156,0,21.226,0,13.508V9.648C0,1.93,1.93,0,9.648,0h19.3c7.719,0,9.648,1.93,9.648,9.648v3.859C38.593,21.226,36.664,23.156,28.945,23.156Z",
    transform: "translate(3.859 19.297)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H46.312V46.312H0Z",
    transform: "translate(46.312 46.312) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.44d1860312e15f4320b4dc033f87dbfe.svg";
export { ForwardRef as ReactComponent };